import jq from 'jquery';

const url = '/api/users/0.1/users/check/?recommend_name=true';
const dfd = jq.Deferred();
let isAsync = true;

function init(asyncParam) {
  if (typeof asyncParam !== 'undefined') {
    isAsync = !!asyncParam;
  }
}

function suggestUsername(emailInput) {
  const emailData = {
    user: {
      email: emailInput,
    },
  };

  jq
    .ajax({
      url,
      contentType: 'application/json; charset=utf-8',
      type: 'POST',
      data: JSON.stringify(emailData),
      dataType: 'json',
      async: isAsync,
    })
    .success(response => {
      if (response.status === 'success') {
        dfd.resolve(response);
      } else {
        dfd.reject(response);
      }
    });

  return dfd.promise();
}

export const usernameSuggester = {
  suggestUsername,
  init,
};
